import styled from 'foundations-theming/utils';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Box } from 'foundations-components/transitional/components/Box';
import { H1 } from 'foundations-components/transitional/components/H1';
import { H4 } from 'foundations-components/transitional/components/H4';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';

// @ts-expect-error Could not find a declaration file for module
import blobsImageUrl from 'bender-url!../../../images/storefront-header-blobs.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeadingContainer = styled.div.withConfig({
  displayName: "Heading__HeadingContainer",
  componentId: "sc-1dmf1ap-0"
})(({
  isMobile,
  theme
}) => ({
  padding: isMobile ? theme.space['200'] : theme.space['400'],
  background: theme.color['fill-accent-teal-default'],
  backgroundImage: isMobile ? 'none' : `url(${blobsImageUrl}), linear-gradient(to right,${theme.color['fill-accent-teal-pressed']},${theme.color['fill-accent-teal-default']})`,
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'auto 100%'
}));
const Heading = ({
  title,
  subtitle,
  leftContent,
  rightContent
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(HeadingContainer, {
    isMobile: isMobile,
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      blockSize: isMobile ? 'auto' : '180px',
      flexDirection: isMobile ? 'column' : 'row',
      children: [/*#__PURE__*/_jsx(Box, {
        basis: 0,
        grow: 1,
        children: leftContent
      }), /*#__PURE__*/_jsx(Box, {
        basis: 0,
        grow: 1,
        children: isMobile ? /*#__PURE__*/_jsx(H4, {
          color: "text-primary-default",
          paddingBlockStart: "300",
          textAlign: "center",
          children: title
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(H1, {
            color: "text-primary-default",
            marginBlockEnd: "300",
            paddingBlockStart: "400",
            textAlign: "center",
            children: title
          }), /*#__PURE__*/_jsx(Text, {
            color: "text-primary-default",
            textAlign: "center",
            typography: "body-200",
            children: subtitle
          })]
        })
      }), /*#__PURE__*/_jsx(Box, {
        basis: 0,
        grow: 1,
        children: rightContent
      })]
    })
  });
};
export default Heading;